/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { requestLoginCode, verifyLoginCode } from "../../actions";
import { connect } from "react-redux";
import Inputs from "../../components/Inputs";
import ArrowDown from "../../assets/icons/arrow-down.svg";
import "./styles.scss";

const Login = ({ requestLoginCode, verifyLoginCode, auth }) => {
  const [step, setStep] = useState("email"); // "email" or "code"
  const [codeStatus, setCodeStatus] = useState(null); // null, "error", "success"
  const [payload, setPayload] = useState({
    email: "",
    code: ["", "", "", ""],
  });

  const codeInputRefs = [useRef(), useRef(), useRef(), useRef()];

  // Auto-focus first code input when entering code step
  useEffect(() => {
    if (step === "code" && codeInputRefs[0].current) {
      setTimeout(() => {
        codeInputRefs[0].current.focus();
      }, 100);
    }
  }, [step]);

  // Handle auth state changes
  useEffect(() => {
    if (auth?.requestLoginCodeSuccess) {
      setStep("code");
    }
    if (auth?.verifyLoginCodeSuccess) {
      setCodeStatus("success");
    }
    if (auth?.error) {
      if (step === "code") {
        setCodeStatus("error");
      }
    }
  }, [auth, step]);

  

  const handleEmailSubmit = () => {
    
    
    if (!payload.email.trim()) {
      console.log("❌ Email is empty, returning");
      return;
    }
    
    
    requestLoginCode({ email: payload.email.trim() });
  };

 const handleCodeSubmit = () => {
  const fullCode = payload.code.join("");
  
  if (fullCode.length !== 4) {
    console.log("❌ Code incomplete, returning");
    return;
  }
  
  setCodeStatus(null);
  verifyLoginCode({ 
    email: payload.email.trim(), 
    code: fullCode 
  });
};

  const handleBackToEmail = () => {
    setStep("email");
    setCodeStatus(null);
    setPayload({ ...payload, code: ["", "", "", ""] });
  };

  const handleCodeInputChange = (index, value) => {
    // Reset error state when user starts typing
    if (codeStatus === "error") {
      setCodeStatus(null);
    }
    
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newCode = [...payload.code];
      newCode[index] = value;
      setPayload({ ...payload, code: newCode });

      // Auto-focus next input
      if (value && index < 3) {
        codeInputRefs[index + 1].current?.focus();
      }
      
      // Auto-submit when all 4 digits are entered
      if (value && index === 3) {
        const completeCode = [...newCode];
        completeCode[index] = value;
        if (completeCode.every(digit => digit !== "")) {
          setTimeout(() => {
            handleCodeSubmit();
          }, 100);
        }
      }
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace to focus previous input
    if (e.key === 'Backspace' && !payload.code[index] && index > 0) {
      codeInputRefs[index - 1].current?.focus();
    }
    
    // Handle Enter key
    if (e.key === 'Enter') {
      if (step === "email") {
        handleEmailSubmit();
      } else if (step === "code") {
        handleCodeSubmit();
      }
    }
  };

  const handleResendCode = () => {
    setCodeStatus(null);
    setPayload({ ...payload, code: ["", "", "", ""] });
    requestLoginCode({ email: payload.email.trim() });
  };

  const isCodeComplete = payload.code.every(digit => digit !== "");
  const loading = auth?.loading || false;

  return (
    <div className="login-page-container">
      <div className="left-login-container">
        <div className="login-logo" />
        
        {step === "email" ? (
          <>
            <h3 style={{ fontSize: "23px", marginTop: "5px" }}>LOG IN</h3>
            <h4 className="subtext_login">Please enter your email address</h4>
            <Inputs.TextInput
              label={"Email"}
              type="email"
              style={{
                width: "95%",
                marginLeft: "1%",
                padding: "1vw",
                marginTop: "8%",
              }}
              inputStyle={{ border: "0.5px solid #002C78" }}
              value={payload.email}
              onChange={(e) => {
                setPayload({ ...payload, email: e.target.value });
              }}
              onKeyDown={(e) => handleKeyDown(0, e)}
            />
            <Inputs.Button
              onClick={handleEmailSubmit}
              text={loading ? "SENDING..." : "CONTINUE"}
              selected
              disabled={loading || !payload.email.trim()}
              className="continue_button_login"
            />
          </>
        ) : (
          <>
            <div className="code-header">
              <img 
                src={ArrowDown} 
                alt="Back" 
                className="back-arrow"
                onClick={handleBackToEmail}
              />
              <h3 style={{ fontSize: "23px", margin: 0 }}>CODE VERIFICATION</h3>
            </div>
            <h4 className="subtext_login">Please enter the 4-digit code we've send to you via email:</h4>
            <div className="email-display">{payload.email}</div>
            
            <div className="code-inputs-container">
              {payload.code.map((digit, index) => (
                <input
                  key={index}
                  ref={codeInputRefs[index]}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleCodeInputChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  className={`code-input-box ${codeStatus === "error" ? "error" : ""} ${codeStatus === "success" ? "success" : ""}`}
                  disabled={loading}
                />
              ))}
            </div>

            <div className={`resend-container ${codeStatus === "error" ? "error" : ""}`}>
              {codeStatus === "error" ? (
                <>
                  <span>Your code is incorrect! </span>
                  <span className="resend-link" onClick={handleResendCode}>
                    Send again
                  </span>
                </>
              ) : (
                <>
                  <span>Didn't receive the code? </span>
                  <span className="resend-link" onClick={handleResendCode}>
                    Send again
                  </span>
                </>
              )}
            </div>

            <Inputs.Button
              onClick={handleCodeSubmit}
              text={loading ? "LOGGING IN..." : "LOG IN"}
              selected
              disabled={loading || !isCodeComplete}
              className="continue_button_login"
            />
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  requestLoginCode: (payload) => dispatch(requestLoginCode(payload)),
  verifyLoginCode: (payload) => dispatch(verifyLoginCode(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
                  